import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { WebsitePageLayout } from 'src/shared/types/website-settings-types'

interface GetWebsiteLayoutPageId {
  layouts: WebsitePageLayout[]
  currentLocale: PageLocaleEnum
}

export const getWebsiteLayoutPageIdForLocale = ({
  layouts,
  currentLocale,
}: GetWebsiteLayoutPageId): number | undefined => {
  const byCurrentLocale = layouts.find(
    layout => layout.locale === currentLocale,
  )
  if (byCurrentLocale) {
    return byCurrentLocale.id
  }

  return layouts[0]?.id
}
